import React from 'react'
import {Licitacion} from  '../models/Licitacion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye } from '@fortawesome/free-solid-svg-icons'
import {  Button  , Nav} from 'react-bootstrap'

import '../components/ComponentLicitacionList.scss'
interface ProductProps{
    licitacion:Licitacion,
    setLicitacionForm: (lic: Licitacion)=>void;
}

const ComponentLicatacionList: React.FC<ProductProps> = (props)=>{
    const setLicitacionForm=(lic: Licitacion)=>{
        props.setLicitacionForm(lic)
    }
    const slect_icon    = <FontAwesomeIcon className="form-ver-lic"   icon={faEye} />
    return(
        <tr onClick={()=> setLicitacionForm(props.licitacion)}>
            <td hidden>{props.licitacion.id}</td>
            <td>{props.licitacion.name}</td>
            <td>{props.licitacion.type.slice(0,1).toUpperCase() 
            + props.licitacion.type.slice(1, props.licitacion.type.length)}</td>
            <td>{props.licitacion.title}</td>
            <td><Nav.Link className="nav-list-button"   eventKey="/en_evaluacion" href={"?state="+props.licitacion.state  + "?id="+ props.licitacion.id}>
                <Button className="registrar-button update-stock-button" size="sm">{slect_icon}</Button>
            </Nav.Link></td>
        </tr>
    )
}

export default ComponentLicatacionList